import {IState, ACTION_VERBS} from './Types';

import {parser} from './Parser';
import {IRequestsToSync} from '../../interfaces/dtos/requests-to-sync.interface';

/**
 *
 */
export const initialState: IState = {
  errors: [],
  clients: null,
  salesTerritories: [],
  customerTypes: [],
  salesmanNewClientRequest: null,
  customerRequiredDocumentList: [],
  salesmanProductList: null,
  customerRequiredDocumentsHelp: null,
  customerPaymentOptions: [],
  salesmanProductToAdd: null,
  customerOrder: null,
  salesmanOrderItemCandidate: null,
  client: undefined,
  balanceCustomer: null,
  balanceSheet: null,
  history: null,
  balances: null,
  semaphoreItems: null,
  debtors: null,
  receivables: null,
  salesCities: [],
  salesCategories: [],
  salesmanPortfolioFilter: null,
  orderList: null,
  orderDetail: null,
  salesmanOrderFilter: null,
  schedule: null,
  appointment: null,
  invoiceCandidates: null,
  invoiceCandidate: null,
  invoiceRequest: null,
  invoiceItemEditing: null,
  requestsToSync: {
    customerRegistryList: [],
    salesOrderList: [],
    invoiceList: [],
    paymentReportList: [],
  } as IRequestsToSync,
  orderCandidates: null,
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export const reducer = (state: IState, action: any) => {
  const {
    CLEAR_ERRORS,
    GET_SALESMAN_CLIENTS,
    BALANCE_SHEET,
    SET_SALESMAN_PRODUCTS,
    SET_SALESMAN_PRODUCT_TO_ADD,
    UPDATE_SALESMAN_NEW_ORDER,
    UPDATE_ORDER_ITEM_CANDIDATE_SHOPPING_CART,
    SEND_SALESMAN_NEW_ORDER,
    SET_SALESMAN_CLIENT,
    FETCH_BALANCE_CLIENT,
    SALESMAN_NEW_CLIENT_REQUEST,
    SEND_SALESMAN_NEW_CLIENT_REQUEST,
    SALESMAN_RESOURCES,
    CLIENT_HISTORY_LIST,
    CUSTOMER_BALANCE_LIST,
    SEMAPHORE_ITEMS,
    DEBTOR_LIST,
    RECEIVABLE_LIST,
    SET_PORTFOLIO_FILTER,
    GET_SALESMAN_ORDER_LIST,
    GET_SALESMAN_ORDER_DETAIL,
    SET_ORDER_FILTER,
    SET_SCHEDULE,
    SET_APPOINTMENT,
    FETCH_INVOICE_CANDIDATES,
    SET_INVOICE_CANDIDATE,
    SET_INVOICE_REQUEST,
    SET_INVOICE_ITEMS_EDITING,
    SEND_SALESMAN_INVOICE_REQUEST,
    RETRIEVE_REQUESTS_TO_SERVER,
    CLEAR_REQUESTS_TO_SERVER,
    UPDATED_REQUESTS_SAVED_TO_STORAGE,
    SYNC_NEW_CLIENT_REQUEST,
    SEND_SALESMAN_NEW_PROOF_OF_PAYMENT,
    SYNC_PROOF_OF_PAYMENT_REPORT_REQUEST,
    SYNC_SALES_ORDER_REQUEST,
    FETCH_ORDER_CANDIDATES,
    FETCH_CANDIDATE_ORDER_DETAIL,
  } = ACTION_VERBS;
  const cleaning = {...state, errors: []};

  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...cleaning,
      };
    case BALANCE_SHEET:
      return {
        ...parser.balanceSheetSalesman(state, action.payload),
      } as IState;
    case GET_SALESMAN_CLIENTS:
      return {
        ...parser.salesmanClientList(state, action.payload),
      } as IState;
    case SET_SALESMAN_PRODUCTS:
      return {
        ...parser.salesmanProductList(state, action.payload),
      } as IState;
    case SET_SALESMAN_PRODUCT_TO_ADD:
      return {
        ...parser.setSalesmanProductToAdd(state, action.payload),
      } as IState;
    case UPDATE_SALESMAN_NEW_ORDER:
      return {
        ...parser.updateSalesmanNewOrder(state, action.payload),
      } as IState;

    case UPDATE_ORDER_ITEM_CANDIDATE_SHOPPING_CART:
      return {
        ...parser.updateCandidateToShoppingCart(state, action.payload),
      } as IState;
    case SEND_SALESMAN_NEW_ORDER:
      return {
        ...parser.sendSalesmanNewOrder(state),
      } as IState;
    case SET_SALESMAN_CLIENT:
      return {
        ...parser.setSalesmanClient(state, action.payload),
      } as IState;
    case FETCH_BALANCE_CLIENT:
      return {
        ...parser.fetchBalanceCustomer(state, action.payload),
      } as IState;
    case SALESMAN_NEW_CLIENT_REQUEST:
      return {
        ...parser.setNewSalesmanClientRequest(state, action.payload),
      } as IState;
    case SEND_SALESMAN_NEW_CLIENT_REQUEST:
      return {
        ...parser.processNewClientRequest(state),
      } as IState;
    case SALESMAN_RESOURCES:
      return {
        ...parser.processResources(state, action.payload),
      } as IState;
    case CLIENT_HISTORY_LIST:
      return {
        ...parser.setClientHistory(state, action.payload),
      } as IState;
    case CUSTOMER_BALANCE_LIST:
      return {
        ...parser.balanceList(state, action.payload),
      } as IState;
    case SEMAPHORE_ITEMS:
      return {
        ...parser.semaphoreItems(state, action.payload),
      } as IState;
    case DEBTOR_LIST:
      return {
        ...parser.debtorList(state, action.payload),
      } as IState;
    case RECEIVABLE_LIST:
      return {
        ...parser.receivableList(state, action.payload),
      } as IState;
    case SET_PORTFOLIO_FILTER:
      return {
        ...parser.setPortfolioFilter(state, action.payload),
      } as IState;
    case SET_ORDER_FILTER:
      return {
        ...parser.setSalesmanOrderFilter(state, action.payload),
      } as IState;

    case GET_SALESMAN_ORDER_LIST:
      return {
        ...parser.setSalesmanOrderList(state, action.payload),
      } as IState;
    case GET_SALESMAN_ORDER_DETAIL:
      return {
        ...parser.setSalesmanOrderDetail(state, action.payload),
      } as IState;
    case SET_SCHEDULE:
      return {
        ...parser.setSchedule(state, action.payload),
      } as IState;
    case SET_APPOINTMENT:
      return {
        ...parser.setAppointment(state, action.payload),
      } as IState;
    case FETCH_INVOICE_CANDIDATES:
      return {
        ...parser.setState('invoiceCandidates', state, action.payload),
      } as IState;
    case SET_INVOICE_CANDIDATE:
      return {
        ...parser.setState('invoiceCandidate', state, action.payload),
      } as IState;
    case SET_INVOICE_REQUEST:
      return {
        ...parser.setState('invoiceRequest', state, action.payload),
      } as IState;
    case SET_INVOICE_ITEMS_EDITING:
      return {
        ...parser.setState('invoiceItemEditing', state, action.payload),
      } as IState;
    case SEND_SALESMAN_INVOICE_REQUEST:
      return {
        ...parser.sendInvoiceRequest(state, action.payload),
      } as IState;
    case RETRIEVE_REQUESTS_TO_SERVER:
      return {
        ...parser.setState('requestsToSync', state, action.payload),
      } as IState;
    case CLEAR_REQUESTS_TO_SERVER:
      return {
        ...parser.setState('requestsToSync', state, {
          customerRegistryList: [],
          salesOrderList: [],
          invoiceList: [],
          paymentReportList: [],
        }),
      } as IState;
    case UPDATED_REQUESTS_SAVED_TO_STORAGE:
      return {
        ...parser.setState('requestsToSync', state, action.payload),
      } as IState;
    case SYNC_NEW_CLIENT_REQUEST:
      return {
        ...parser.syncNewCustomer(state, action.payload),
      } as IState;
    case SYNC_PROOF_OF_PAYMENT_REPORT_REQUEST:
      return {
        ...parser.syncPaymentProofReport(state, action.payload),
      } as IState;
    case SYNC_SALES_ORDER_REQUEST:
      return {
        ...parser.syncNewSalesOrder(state, action.payload),
      } as IState;
    case FETCH_ORDER_CANDIDATES:
      return {
        ...parser.setState('orderCandidates', state, action.payload),
      } as IState;
    case FETCH_CANDIDATE_ORDER_DETAIL:
      return {
        ...parser.buildFropmCandidateToCustomerOrder(state, action.payload),
      } as IState;
    case SEND_SALESMAN_NEW_PROOF_OF_PAYMENT:
    default:
      return state;
  }
};
